export const removeUrlProtocol = (url: string): string => {
    const protocolPattern = /^https?:\/\//i;

    // If the URL matches the protocol pattern, replace it with an empty string
    return url.replace(protocolPattern, "");
};
